import { STELLA_ACCESS_CODE } from "@/consts";
import { getAccessCode } from "@/lib/utils";

export const getIsStellaAccessCode = () => {
  return getAccessCode() === STELLA_ACCESS_CODE;
};
